import { render, staticRenderFns } from "./storeColdRecord.vue?vue&type=template&id=9ed60eba"
import script from "./storeColdRecord.vue?vue&type=script&lang=js"
export * from "./storeColdRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports